module.exports = __webpack_public_path__ + "img/tabs-image-01.7095dc71.jpg";